/**
 * Sanitização mínima para HTML gerido no painel (evita script/iframes e handlers).
 */
export function sanitizeCmsHtml(html: string): string {
  let s = html;
  s = s.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');
  s = s.replace(/<iframe\b[^<]*(?:(?!<\/iframe>)<[^<]*)*<\/iframe>/gi, '');
  s = s.replace(/\son\w+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, '');
  s = s.replace(/javascript:/gi, '');
  s = s.replace(/<object\b[^<]*(?:(?!<\/object>)<[^<]*)*<\/object>/gi, '');
  s = s.replace(/<embed\b[^>]*>/gi, '');
  return s;
}

export function looksLikeHtml(s: string): boolean {
  return /<[a-z][\s\S]*>/i.test(s.trim());
}

/**
 * Descodifica entidades HTML comuns (`&nbsp;`, `&amp;`, …), inclusive dupla
 * codificação (`&amp;nbsp;`). Útil quando texto entre tags é renderizado como
 * children React (que não interpretam entidades).
 */
export function decodeHtmlEntities(text: string): string {
  if (!text || !text.includes('&')) return text;

  let cur = text;
  for (let pass = 0; pass < 3; pass++) {
    const next = cur
      .replace(/&nbsp;/gi, '\u00A0')
      .replace(/&#160;/g, '\u00A0')
      .replace(/&#x0*a0;/gi, '\u00A0')
      .replace(/&amp;/gi, '&')
      .replace(/&lt;/gi, '<')
      .replace(/&gt;/gi, '>')
      .replace(/&quot;/gi, '"')
      .replace(/&apos;/gi, "'")
      .replace(/&#(\d+);/g, (match, n: string) => {
        const code = Number(n);
        return Number.isFinite(code) ? String.fromCodePoint(code) : match;
      })
      .replace(/&#x([0-9a-f]+);/gi, (match, h: string) => {
        const code = parseInt(h, 16);
        return Number.isFinite(code) ? String.fromCodePoint(code) : match;
      });
    if (next === cur) break;
    cur = next;
  }
  return cur;
}

/** Normaliza HTML do contenteditable: `&nbsp;` → espaço (evita lixo visual ao re-editar). */
export function normalizeEditorHtml(html: string): string {
  if (!html) return html;
  return html.replace(/&nbsp;/gi, ' ').replace(/\u00A0/g, ' ');
}
